export default "/_next/static/chunks/fonts/lato-700-italic-21fd3e9e128dfaa1e161481712abf1cf.woff2";